module.exports = __webpack_public_path__ + "media/blog_cannot_send_animation.ad30601f.mp4";